module.exports = __webpack_public_path__ + "static/bg-video-428fb881385115f3ddf322fba6ed33a6.mp4";